module.exports = __webpack_public_path__ + "static/img/welfare5.d33db134.jpg";